import { FormattedNumber, FormattedMessage } from 'react-intl';

export default function formatMessageWithPrice(message, info) {
  const minimumFractionDigits = _.get(info, 'digits', _.isInteger(info.price) ? 0 : 2);
  return (
    <FormattedNumber value={info.price}
                     style="currency"
                     currency={info.currency}
                     minimumFractionDigits={minimumFractionDigits}>
      {price => (
        <FormattedMessage {...message}
                          values={{ price }} />
      )}
    </FormattedNumber>
  );
}



// WEBPACK FOOTER //
// ./src/shared/utils/format-message-with-price.js